var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-logo",class:{'animate-logo':_vm.animateLogo }},[_c('div',{ref:"logoAnimation",staticClass:"logo",on:{"click":_vm.resetState}})])}
var staticRenderFns = []

export { render, staticRenderFns }